import { useNavigationType } from 'hooks/useNavigate';
import React, { useEffect } from 'react';
import { FlowComponentType } from 'routes/types';

const PopBackRedirect = ({ handleNext }: FlowComponentType) => {
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') {
      handleNext();
    }
  });

  return <div />;
};

export default PopBackRedirect;
